module.exports = __webpack_public_path__ + "img/图片3.cc5addc6.png";